import { render, staticRenderFns } from "./CategoryAmountQuantitySalesCmp.vue?vue&type=template&id=6f683f64&"
import script from "./CategoryAmountQuantitySalesCmp.vue?vue&type=script&lang=js&"
export * from "./CategoryAmountQuantitySalesCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports